// Datos de pricing para upgrade de usuarios Dashbo Connect Individual
// Dos opciones: Connect Multi-Cliente ($80/mo) y Big Agency ($240/mo, toma el precio de pricingConfig)

import { PLANS as DASHBO_PLANS } from '../pricingConfig';

// Reutilizar precios exactos de Big Agency del config principal
const bigAgencyPrices = DASHBO_PLANS.find(p => p.id === 'big_agency').prices;

export const MCP_PLANS = [
    {
        id: 'connect_multi',
        nameKey: 'mcp_upgrade.plans.connect_multi.name',
        descriptionKey: 'mcp_upgrade.plans.connect_multi.description',
        badgeKey: 'mcp_upgrade.plans.connect_multi.badge',
        prices: {
            usd: { monthly: 80, trimestral: 72, semestral: 64, yearly: 56 },
            ars: { monthly: 131162, trimestral: 118045, semestral: 104929, yearly: 91813 },
        },
        features: [
            { key: 'ad_accounts_30', labelKey: 'mcp_upgrade.features.connect_multi.ad_accounts', included: true },
            { key: 'all_platforms', labelKey: 'mcp_upgrade.features.connect_multi.all_platforms', included: true },
            { key: 'unlimited_queries', labelKey: 'mcp_upgrade.features.connect_multi.unlimited_queries', included: true },
            { key: 'rest_mcp', labelKey: 'mcp_upgrade.features.connect_multi.rest_mcp', included: true },
            { key: 'refresh_3h', labelKey: 'mcp_upgrade.features.connect_multi.refresh_3h', included: true },
            { key: 'email_support', labelKey: 'mcp_upgrade.features.connect_multi.email_support', included: true },
            { key: 'no_budgets', labelKey: 'mcp_upgrade.features.connect_multi.no_budgets', included: false },
            { key: 'no_alerts', labelKey: 'mcp_upgrade.features.connect_multi.no_alerts', included: false },
            { key: 'no_dashboard', labelKey: 'mcp_upgrade.features.connect_multi.no_dashboard', included: false },
        ],
    },
    {
        id: 'big_agency',
        nameKey: 'mcp_upgrade.plans.big_agency.name',
        descriptionKey: 'mcp_upgrade.plans.big_agency.description',
        badgeKey: 'mcp_upgrade.plans.big_agency.badge',
        highlighted: true,
        prices: bigAgencyPrices,
        features: [
            { key: 'ad_accounts_150', labelKey: 'mcp_upgrade.features.big_agency.ad_accounts', included: true },
            { key: 'unlimited_budgets', labelKey: 'mcp_upgrade.features.big_agency.unlimited_budgets', included: true },
            { key: 'multichannel_alerts', labelKey: 'mcp_upgrade.features.big_agency.multichannel_alerts', included: true },
            // Pricing del 2026-10-05: todas las funciones en todos los planes; Big y Epic suman el servicio.
            { key: 'all_features', labelKey: 'mcp_upgrade.features.big_agency.all_features', included: true },
            { key: 'multi_agencies', labelKey: 'mcp_upgrade.features.big_agency.multi_agencies', included: true },
            { key: 'onboarding_priority_support', labelKey: 'mcp_upgrade.features.big_agency.onboarding_priority_support', included: true },
            { key: 'connect_included', labelKey: 'mcp_upgrade.features.big_agency.connect_included', included: true },
        ],
    },
];
